import { render } from "./Nonconforming.vue?vue&type=template&id=047acd99"
import script from "./Nonconforming.vue?vue&type=script&lang=js"
export * from "./Nonconforming.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__